<div class="inner-page-header">
  <div class="titles">
    <h3 class="title">المجموعات / {{ title}}</h3>
  </div>
</div>

<form class="needs-validation" id="general-form" [formGroup]="cohortFormGroup">
  <div class="cohort-content">
    <div class="title-wrapper">
      <h3 class="font-20 font-bold">{{ title }}</h3>
      <div class="actions">
        <button type="button" class="btn btn-cancel" (click)="goBack()">رجوع</button>
        <app-action-button (submitAction)="save($event)"></app-action-button>
      </div>
    </div>

    <div class="main-card">
      <div class="form-group">
        <label for="" class="form-label">
          اسم المجموعة
          <span class="red">*</span>
        </label>
        <input type="text" class="form-control" formControlName="name" />
      </div>

      <div class="form-group">
        <label for="" class="form-label">وصف المجموعة <span class="red">*</span></label>
        <textarea class="form-control" name="description" rows="4" formControlName="description"
          maxlength="500"></textarea>
      </div>
    </div>

    <div class="main-card">
      <div class="form-group">
        <label for="" class="form-label">
          التخصصات
          <span class="red">*</span>
        </label>
        <app-select [optionItems]="specializations" [id]="'specializations'" [placeholder]="'إضافة تخصصات للمجموعة'"
          [bindLabel]="'name_ar'" [bindValue]="'id'" [initValues]="initSpecializations"
          (selectedOptions)="setSpecializations($event)" (onScrollValues)="onScrollSpecializationsPagination($event)"
          (updateOptions)="updateSpecializations($event)">
        </app-select>
      </div>
    </div>

    @if (this.cohortId !== 'add') {
    <div class="main-card">
      <div class="title-wrapper mt-0 mx-0">
        <h3 class="font-20 font-bold">الخبراء</h3>
        <div class="actions">
          <button type="button" class="btn btn-add" (click)="addExpert()">
            <img src="assets/images/svg/add-icon.svg" alt="" />
            إضافة خبير
          </button>
        </div>
      </div>

      <div class="request-table px-0 mt-3">
        <div class="table-responsive">
          <table id="order-table" aria-label="" class="table table-striped">
            <thead>
              <tr>
                <th>الخبير</th>
                <th class="width-40">التخصص</th>
                <th class="width-25">-</th>
              </tr>
            </thead>
            <tbody>
              @for (expert of experts; track expert.id; let i = $index) {
              <tr class="table-row">
                <td>{{ expert.expert?.first_name }} {{ expert.expert?.last_name }}</td>
                <td>{{ expert.specializations?.map(spec => spec.name_ar).join(', ') }}</td>
                <td>
                  <div class="actions">
                    <button class="btn btn-table-edit" (click)="editExpert(expert)">
                      <img src="assets/images/svg/edit-icon.svg" alt="تعديل" />
                      تعديل
                    </button>
                    <button class="btn btn-table-edit" (click)="deleteExpert(expert.expert?.id, i)">
                      <img src="assets/images/svg/DELETE1.svg" alt="حذف" />
                      حذف
                    </button>
                  </div>
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>

    @if (cohortLog.length > 0) {
    <div class="main-card">
      <div class="title-wrapper mt-0 mx-0">
        <h3 class="font-20 font-bold">سجل التغييرات</h3>
      </div>
      <div class="logs-content">
        @for (log of cohortLog; track log.id) {
        <div class="log">
          <div class="blue-bullet"></div>
          <div class="log-content">
            <p class="font-semibold">{{ log.change_message }}</p>
            <p class="log-desc font-semibold">
              بواسطة
              <span dir="auto">{{ log.changed_by_name }}</span> ·
              {{ log.changed_at | date:'yyyy-MM-dd HH:mm' }}
            </p>
          </div>
        </div>
        }
      </div>
    </div>
    }
    }
  </div>
</form>
